// RelatedDestinations — horizontal carousel of internal SEO links (nearby,
// similar_vibe, alternative). Each card navigates to the related guide page.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { B } from '../constants';

const RELATION_LABELS = {
  nearby: 'Nearby',
  similar_vibe: 'Similar vibe',
  alternative: 'Alternative',
};

function slugify(name) {
  return String(name || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-+$/, '');
}

export default function RelatedDestinations({ items }) {
  const navigate = useNavigate();
  if (!items || items.length === 0) return null;

  return (
    <section style={{ margin: '32px 0' }}>
      <h2 style={{
        fontFamily: "'Playfair Display',serif", color: B.night, fontSize: 24, marginBottom: 12,
      }}>
        Related destinations
      </h2>
      <div
        style={{
          display: 'flex', gap: 12, overflowX: 'auto', paddingBottom: 8,
          scrollSnapType: 'x mandatory',
        }}
      >
        {items.map((item, idx) => {
          const d = item.destination || {};
          const slug = d.slug || slugify(d.name);
          return (
            <button
              key={d.id ?? idx}
              type="button"
              onClick={() => navigate(`/guide/${slug}`)}
              style={{
                minWidth: 220, maxWidth: 240, flex: '0 0 auto',
                background: '#fff', border: `1px solid ${B.sand}`, borderRadius: 12,
                padding: 0, cursor: 'pointer', textAlign: 'left', overflow: 'hidden',
                scrollSnapAlign: 'start',
              }}
            >
              {d.img && (
                <img
                  src={d.img}
                  alt={d.name}
                  style={{ width: '100%', height: 120, objectFit: 'cover', display: 'block' }}
                />
              )}
              <div style={{ padding: 12 }}>
                <div style={{
                  fontSize: 11, color: B.forest, textTransform: 'uppercase',
                  letterSpacing: 0.5, marginBottom: 4,
                }}>
                  {RELATION_LABELS[item.relation] || item.relation}
                </div>
                <div style={{
                  fontFamily: "'Playfair Display',serif", color: B.night,
                  fontSize: 18, marginBottom: 4,
                }}>
                  {d.name}
                </div>
                <div style={{ fontSize: 13, color: B.muted }}>
                  {d.days ? `${d.days} days` : ''}
                  {d.rating ? `${d.days ? ' · ' : ''}★ ${d.rating}` : ''}
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </section>
  );
}
